"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var parent_node_view_styles_1 = require("./parent-node-view.styles");

var scenario_node_gallery_card_component_1 = __importDefault(require("../scenario-node-gallery-card/scenario-node-gallery-card.component"));

var ParentNodeView = function ParentNodeView(_ref) {
  var node = _ref.node,
      onClick = _ref.onClick;
  return react_1.default.createElement(parent_node_view_styles_1.StyledParentNoderDiv, null, react_1.default.createElement(scenario_node_gallery_card_component_1.default, {
    node: node,
    onCardClick: onClick,
    enableDetailView: true
  }), react_1.default.createElement(parent_node_view_styles_1.StyledFontAwesomeIcon, {
    icon: 'angle-double-right'
  }));
};

exports.default = ParentNodeView;